
















































































































































import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    FormBase: () => import('@/components/forms/Base.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    FormOrderAddress: () => import('@/components/forms/Address.vue'),
    CafkaLogs: () => import('@/components/parts/CafkaLogs.vue'),
  },
})
export default class PageOrderDetail extends Vue {
  @Getter('order/viewing') order!: Order;

  @Getter('log/all') logs!: Log[];

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('log/index') getLogs!: (payload: { id: number; query?: IndexQuery<Log>; workspaceId: number }) => Promise<Log[]>;

  @Action('order/reHandle') reHandle!: ({ id, workspaceId }: { id: number; workspaceId: number }) => Promise<void>;

  formLoaded: boolean = false;

  reHandling = false;

  reHandled = false;

  get subtotal() {
    let total = 0;
    this.order.order_products.forEach((orderProduct: OrderProduct) => {
      total += orderProduct.price * orderProduct.quantity;
    });

    return total;
  }

  get taxTotal() {
    let total = 0;
    this.order.order_products.forEach((orderProduct: OrderProduct) => {
      total += orderProduct.price_tax_total;
    });
    total += this.order.shipping_costs_tax;
    total += this.additionalCosts.reduce((sum: number, additionalCost) => sum + additionalCost.price_tax, 0);

    return total;
  }

  get total() {
    const additionalCosts = this.additionalCosts.reduce((sum: number, additionalCost) => sum + additionalCost.price, 0);

    let transactionCosts = 0;
    if (this.order.shipping_costs_tax_rate > 0) {
      transactionCosts = this.order.transaction_costs ? this.order.transaction_costs * (1 + this.order.shipping_costs_tax_rate) : 0;
    } else {
      transactionCosts = this.order.transaction_costs ? this.order.transaction_costs : 0;
    }

    return this.subtotal + this.order.shipping_costs + this.taxTotal + additionalCosts + transactionCosts;
  }

  get additionalCosts() {
    if (!this.order.additional_costs) {
      return [];
    }

    const keyValues: { [key: string]: { price: number; price_tax: number } } = this.order.additional_costs;
    return Object.keys(this.order.additional_costs).map((key) => ({ key, price: keyValues[key].price, price_tax: keyValues[key].price_tax }));
  }

  async reHandleOrder() {
    this.reHandling = true;
    await this.reHandle({ id: this.order.id, workspaceId: this.workspace.id });
    this.reHandling = false;
    this.reHandled = true;
  }

  @Watch('order', { immediate: true })
  handleOrderChanged(val: Order) {
    if (val && val.id) {
      this.getLogs({ id: val.id, query: { per_page: 1000 }, workspaceId: this.workspace.id });
    }
  }

  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.$router.push({ name: 'orders' });
  }
}
